export default __webpack_public_path__ + "static/media/martin.5754ecb8.png";